<template>
  <div class="container d-flex gallery-main-container">    
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div
      class="image"
      v-for="(image, imageIndex) in images"
      :key="imageIndex"
      @click="index = imageIndex"
      :style="{ backgroundImage: 'url(' + image + ')' }"
    ></div>
  </div>
</template>

<script>
import VueGallery from 'vue-gallery'
import { getDataFromServer } from '../utils/DataProvider'
  export default {
    data: function(){
      return{
        images: ['/image/gallery/tolya-tlush.jpeg', '/image/gallery/tolya-tlush.jpeg'],
        index: null,
      }
    },
    components: {
      'gallery': VueGallery
    },
    created(){      
      getDataFromServer('list_gallery', {mediatype:'image'})
        .then(obj => { 
          if(obj.data.success === true){             
            let arrImages = obj.data.data
            let arrImagesTemp = []
            for(let i = 0; i < arrImages.length; i++){
                arrImagesTemp.push('/image/gallery/' + arrImages[i].link)
            }            
            this.images = arrImagesTemp
          }
          else{
            this.flash('get gallery error: ' + obj.data.text , 'error', {timeout: 5000})
          }          
        })
        .catch(err => { 
          this.flash('get gallery error: ' + obj.data.text , 'error', {timeout: 5000})
      })
    },
  }
</script>

<style scoped>
.gallery-main-container{
  margin-top: 200px;
  margin-bottom: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
  flex: 1 0 300px;
  height: 200px;
  max-width: 300px;
}

@media screen and (max-width: 767px){
  .gallery-main-container{
    margin-top: 90px;
  }
}
</style>
